
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "../../../../common/common-interface";
import { getOrderFaults } from "@/api/api-charge-service";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiChargeOrderTable extends Vue {
  @Prop({ default: "" }) private orderNo!: string;
  private formInline: objAny = {};
  private loading = false;
  private tableList: objAny[] = [];
  private tableColumns: objAny[] = [
    {
      title: i18n.t("orderDetails.faultCode"),
      key: "faultCode",
      minWidth: 120
    },
    {
      title: i18n.t("orderDetails.faultName"),
      key: "faultName",
      minWidth: 120
    },
    {
      title: i18n.t("orderDetails.faultDesc"),
      key: "faultDesc",
      minWidth: 500
    }
  ];
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getOrderFaults({
      orderNo: this.orderNo
    });
    if (ret.status == this["$config"].apiStatus) {
      this.tableList = ret.data || [];
    }
    this.loading = false;
  }

  mounted(): void {
    this.getTableList();
  }
}
